/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */
import AlertComponent from "../components/AlertComponent";
import { FILE_STATUS, THEME, USER_LEVEL } from "../configs/constants";

const cpfFormater = (cpf) => {
  return `${cpf.substring(0, 3)}.${cpf.substring(3, 6)}.${cpf.substring(
    6,
    9
  )}-${cpf.substring(9, 11)}`;
};

const cnpjFormater = (cpf) => {
  return `${cpf.substring(0, 2)}.${cpf.substring(2, 5)}.${cpf.substring(
    5,
    8
  )}/${cpf.substring(8, 12)}-${cpf.substring(12, 14)}`;
};

export const validaPhone = (phone) => {
  try {
    const myPhone = phone.replace(/[^\d]+/g, "");
    if (
      myPhone == null ||
      myPhone === "" ||
      (myPhone.length !== 10 && myPhone.length !== 11)
    )
      return false;
    return true;
  } catch (e) {
    return false;
  }
};

export const mailValidator = (email) => {
  try {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      email
    );
  } catch (e) {
    return false;
  }
};

export const validaCpfCnpj = (val) => {
  return validaCpf(val) || validaCnpj(val);
};

export const isCpf = (val) => {
  return val.length  === 11 && validaCpf(val);
};

export const isCnpj = (val) => {
  try {
    val = val.replace(/[^0-9]/g, "");
    return val.length === 14 && validaCnpj(val);
  }
  catch {}
  return false;
};

export const isEmptyOrNullStr = (val) => {
  if (val === null || val === "" || val === undefined) return true;  
  return false;
};

export const isEmptyOrNullInt = (val) => {
  if (val === null || val === 0 || val === undefined) return true;  
  return false;
};

const validaCpf = (val) => {
  let strCPF = val.trim();
  strCPF = strCPF.replace(/[^0-9]/g, "");
  if (strCPF.length === 11) {
    let Soma, Resto;
    Soma = 0;
    if (strCPF === "00000000000") return false;

    for (let i = 1; i <= 9; i++)
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++)
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
  }
};


const validaCnpj = (val) => {
  const cnpj = val.replace(/[^0-9]/g, "");

  if (cnpj === "") return false;

  if (cnpj.length !== 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj === "00000000000000" ||
    cnpj === "11111111111111" ||
    cnpj === "22222222222222" ||
    cnpj === "33333333333333" ||
    cnpj === "44444444444444" ||
    cnpj === "55555555555555" ||
    cnpj === "66666666666666" ||
    cnpj === "77777777777777" ||
    cnpj === "88888888888888" ||
    cnpj === "99999999999999"
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros[tamanho - i] * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos[0])) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros[tamanho - i] * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos[1])) return false;

  return true;
};

export const documentFormater = (document) => {
  if (document != null) {
    if (document.length === 11) return cpfFormater(document);
    if (document.length === 14) return cnpjFormater(document);
  }
  return "";
};

export const copyToClipBoard = async (copyMe) => {
  try {
    navigator.clipboard.writeText(copyMe).then(
      () => AlertComponent.success("Copiado"),
      (err) => {
        AlertComponent.error("Não Copiado");
      }
    );
  } catch (err) {
    AlertComponent.error("Não Copiado");
  }
};

export const isMobile = () => {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const cnpjMask = (value) => {
  try {
    const numbersOnly = value.replace(/\D+/g, ''); // Remove todos os caracteres não numéricos

    if (numbersOnly.length <= 11) {
      // Aplica a máscara de CPF
      return numbersOnly
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    } else {
      // Aplica a máscara de CNPJ
      return numbersOnly
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
    }
  } catch {
    return "";
  }
}

export const phoneMask = (value) => {
  if (!value) return ""
  value = value.replace(/\D/g,'')
  value = value.replace(/(\d{2})(\d)/,"($1) $2")
  value = value.replace(/(\d)(\d{4})$/,"$1-$2")
  return value
}

export const autoCompleteSx = () => {
  return {
    '& .css-nz481w-MuiInputBase-input-MuiInput-input': {
    color: document.body.classList.contains("white-content") ? 'inherit' : 'rgba(255, 255, 255, 0.8)',
    fontFamily: '"Poppins", sans-serif',
    },
    '& .css-2duac4': {
      color: document.body.classList.contains("white-content") ? 'inherit' : 'rgba(255, 255, 255, 0.8)',
      fontFamily: '"Poppins", sans-serif',
    },
    '& .MuiInput-root.MuiInputBase-sizeSmall': {
      paddingTop: "0px",
      paddingRight: "18px",
      paddingBottom: "10px",
      paddingLeft: "18px"
    },
    '& .css-14xy6th .MuiInput-root.MuiInputBase-sizeSmall': {
      paddingTop: "0px",
      paddingRight: "18px",
      paddingBottom: "10px",
      paddingLeft: "18px"
    }
  }
}

export const autoCompleteMultiSx = () => {
  return {
    '& .css-6od3lo-MuiChip-label': {
    color: document.body.classList.contains("white-content") ? 'inherit' : 'rgba(255, 255, 255, 0.8)',
     fontFamily: '"Poppins", sans-serif',
    },
    '& .css-9iedg7': {
      color: document.body.classList.contains("white-content") ? 'inherit' : 'rgba(255, 255, 255, 0.8)',
      fontFamily: '"Poppins", sans-serif',
    }  
  }
}

export const dateFormat = (date) => {
  var month = '' + (date.getMonth() + 1),
  day = '' + date.getDate(),
  year = date.getFullYear();

  if (month.length < 2) 
    month = '0' + month;
  if (day.length < 2) 
    day = '0' + day;

  return [year, month, day].join('-');
}

export const dateFormatCalender = (date) => {
  try {  
    var year = date.substring(0,4);
    var month = date.substring(5,7);
    var day = date.substring(8,10);

    var result = new Date(parseInt(year), parseInt(month)-1, parseInt(day));
    return result;
  }
  catch {
    return;
  }
}

export const dateFormatString = (date) => {
  try {  
    var year = date.substring(0,4);
    var month = date.substring(5,7);
    var day = date.substring(8,10);

    var result = `${day}/${month}/${year}`;
    return result;
  }
  catch {
    return;
  }
}

export const dateFormat2 = (date) => {
  var year = date.substring(0,4);
  var month = date.substring(5,7);
  var day = date.substring(8,10);

  var hour = date.substring(11,13);
  var minute = date.substring(14,16);
  var second = date.substring(17,19);

  return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
}

export const makeFileStatus = (status) => {
  if (status === FILE_STATUS.waiting)
    return "Aguardando início";
  if (status === FILE_STATUS.pending)
    return "Em processamento";
  if (status === FILE_STATUS.processed)
    return "Processado com sucesso";
  if (status === FILE_STATUS.waitingService)
    return "Aguardando agente";
  return "Erro";
};

export const getVarFromUrl = (variableName) => {
  try {
    variableName = variableName + "=";
    var url = window.location.href;
    var urlSplit = url.split("?");
    var variables = urlSplit[1];
    var variablesSplit = variables.split("&");
    for (let i = 0; i < variablesSplit.length; i++){
      if (variablesSplit[i].includes(variableName)){
        return parseInt(variablesSplit[i].replace(variableName,""));
      } 
    }
  }
  catch
  {
    return 0;
  }  
};

export const getTheme = function() {
  if (document.body.classList.contains("white-content")) 
    return THEME.light;
  return THEME.dark;
};

export const getGridLineColor = function() {
  if (document.body.classList.contains("white-content"))
    return "#D5D5E0"
  return "#1e1e2f";
};

export const getLevelName = function(userLevel) {
  if (userLevel === USER_LEVEL.establishment) {
    return "Estabelecimento";
  }
  else if (userLevel === USER_LEVEL.manager) {
    return "Administrador";
  }
  else {
    return "Revenda";
  }
};

export const valueToValueStr = function(value) {
  try {
    if (value > 0)
      return (value / 100.00).toFixed(2).toString();
    return "0.00";
  }
  catch (e) {
    return "0.00";
  }
};